/**
 * PATH: apps/quote/src/components/builder/scope-ag-grid/ScopeGridFooterHints.tsx
 * FILE_ID: QB-AGGRID-FOOTER-HINTS-001
 * PURPOSE: Compact keyboard / paste cheat-sheet rendered below the
 *          grid, matching SAM's footer strip:
 *          "Tab next cell  Enter next row  Arrows navigate
 *           Scroll right for row assumptions and row overrides
 *           Paste from Excel supported"
 * WHY: New estimators didn't know Tab/Enter/Arrow shortcuts were
 *      supported. Without this strip the grid looked like a
 *      half-finished prototype next to SAM. Pure visual / docs;
 *      no behavior change.
 * FLOW: render constant strings styled as small keyboard pills.
 * DEPENDENCIES: tailwind utility classes.
 * RELATED:
 *   - QB-AGGRID-SECTION-001 — host
 */

const HINTS: Array<[string, string]> = [
  ['Tab', 'next cell'],
  ['Enter', 'next row'],
  ['Arrows', 'navigate'],
]

export default function ScopeGridFooterHints() {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-1 pt-1 text-[10px] text-slate-500 dark:text-slate-400 border-t border-slate-100 dark:border-slate-800">
      {HINTS.map(([key, desc]) => (
        <span key={key} className="inline-flex items-center gap-1">
          <kbd className="px-1 py-0.5 rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 font-mono text-[9px] text-slate-700 dark:text-slate-200">
            {key}
          </kbd>
          <span>{desc}</span>
        </span>
      ))}
      <span className="opacity-80">
        Scroll right for row assumptions and row overrides
      </span>
      <span className="opacity-80">
        Edit row-only rates without changing the sheet defaults
      </span>
      <span className="opacity-80 italic">Paste from Excel supported</span>
    </div>
  )
}
